/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, Input } from '@angular/core';
import { LegendItems } from './legend-item.interface';

//TODO rename to iriro-resource-legend
@Component({
  selector: 'rwc-resource-legend, iriro-resource-legend',
  templateUrl: './resource-legend.component.html',
  styleUrls: ['./resource-legend.component.scss'],
})
export class ResourceLegendComponent {
  @Input() legendItems: Array<LegendItems> | undefined = undefined;
}
